import React from 'react'
import { FormattedMessage } from 'react-intl'
import { PanelMonitorContent } from './PanelMonitorContent'
import { PanelMenuPopOver } from './PanelMenu/PanelMenuPopOver'

import './PanelMonitor.scss'

//
// PanelMonitor
//
// The panel monitor component is the interface for the host to operate with the
// select speaker panel feature and ultimately see the Stage UI reflect these
// changes.
//

interface PanelMonitorProps {
  tint: string
  isSelected: boolean
  onContentClick: () => void
}

const PanelMonitor = ({
  tint,
  isSelected,
  onContentClick,
}: PanelMonitorProps) => {
  return (
    <div
      className="panel-monitor"
      data-selected={isSelected}
      data-accent-color={tint}
    >
      <PanelMonitorContent
        tint={tint}
        isSelected={isSelected}
        onClick={onContentClick}
      />

      <div className="panel-monitor-panel">
        <FormattedMessage defaultMessage="Panel Mix" />
      </div>

      <PanelMenuPopOver />
    </div>
  )
}

export { PanelMonitor }
